module.exports = __webpack_public_path__ + "img/logo2.bbbddc11.png";